import buyerZh from './buyer-zh';

const common = {
  CONFIRM: '确认',
  CANCEL: '取消',
  RESET: '重置',
  SUBMIT: '提交',
  SAVE: '保存',
  REMOVE: '删除',
  SAVING: '保存中',
  FIELD_REQUIRED: '此项为必填',
  SEARCH: '搜索',
  LOADING: '加载中',
  NO_DATA: '暂无数据',
  GO_BACK: '返回',
  COMMON_NONE: '无',
  COMMON_REFRESH: '刷新',
  COMMON_PULL_TO_REFRESH: '下拉刷新',
  COMMON_RELEASE_TO_REFRESH: '释放立即刷新',
  COMMON_REFRESHING: '刷新中…',
  SIGN_IN: '登录',
  PASSWORD: '密码',
  PLEASE_ENTER_YOUR_PASSWORD: '请输入密码',
  PAGE_NOT_FOUND: '页面未找到',
  THE_REQUESTED_PAGE_COULD_NOT_BE_LOCATED: '所请求的页面不存在。',
};

export default {
  translation: {
    ...common,
    ...buyerZh,
  },
};
